<template>
  <header class="py-4 sm:py-6 px-4 sm:px-6 lg:px-60">
    <div class="flex items-center justify-between gap-4">
      <!-- Team Logo & Name -->
      <div class="flex items-center gap-3 sm:gap-4 min-w-0">
        <img
          v-if="teamInfo.logo_url"
          :src="teamInfo.logo_url"
          alt="Team logo"
          class="h-10 w-10 sm:h-12 sm:w-12 object-cover rounded-full flex-shrink-0"
        />
        <div class="min-w-0">
          <h1 class="text-lg sm:text-xl font-bold truncate" :style="{ color: teamPrimaryColor }">
            {{ teamInfo.name }}
          </h1>
          <p v-if="kioskName" class="text-sm font-medium text-gray-500 truncate">
            {{ kioskName }}
          </p>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-3 sm:gap-4 flex-shrink-0">
        <!-- Calendar Icon -->
        <button
          @click="$emit('calendar')"
          class="transition hover:opacity-70"
          :style="{ color: iconColor }"
          title="Calendar"
        >
          <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm-8 4H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z"/>
          </svg>
        </button>
        <!-- Settings Icon -->
        <button
          @click="$emit('settings')"
          class="transition hover:opacity-70"
          :style="{ color: iconColor }"
          title="Settings"
        >
          <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19.14 12.94c.04-.31.06-.63.06-.94 0-.31-.02-.63-.06-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
          </svg>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'KioskHeader',
  props: {
    teamInfo: {
      type: Object,
      required: true,
    },
    currentEvent: {
      type: Object,
      default: null,
    },
    kioskName: {
      type: String,
      default: null,
    },
  },
  emits: ['settings', 'calendar'],
  computed: {
    teamPrimaryColor() {
      return this.teamInfo.brand_color || '#000000';
    },
    iconColor() {
      return '#374151'; // gray-700
    },
  },
};
</script>
